var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-pie"},[_c('mr-echarts',{attrs:{"options":_vm.optionsPie}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }